import { QRCodeSVG } from "qrcode.react";
import { AndroidLogo, CircleNotch, DownloadSimple } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { APK_DOWNLOAD_URL, useDownload } from "@/lib/download";
import { useState } from "react";

export default function DownloadDialog() {
  const { qrOpen, setQrOpen, triggerFileDownload } = useDownload();
  const [starting, setStarting] = useState(false);

  const handleDirectDownload = () => {
    setStarting(true);
    triggerFileDownload();
    setTimeout(() => setStarting(false), 3000);
  };

  return (
    <Dialog open={qrOpen} onOpenChange={setQrOpen}>
      <DialogContent
        data-testid="download-dialog"
        className="max-w-md border-white/10 bg-[#0F172A] text-slate-100"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold tracking-tight text-slate-50">
            Get the Coin Adda App
          </DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-slate-400">
            The Coin Adda app is an Android app. Scan the QR code with your
            Android phone to download it instantly — or open this page on your
            phone and tap Download.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 flex flex-col items-center gap-5">
          <div className="rounded-2xl bg-white p-4" data-testid="download-qr-code">
            <QRCodeSVG value={APK_DOWNLOAD_URL} size={168} level="M" />
          </div>
          <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            <AndroidLogo size={16} weight="duotone" className="text-[#00F5A0]" />
            Scan with your Android phone
          </p>
          <button
            type="button"
            data-testid="dialog-download-anyway-btn"
            onClick={handleDirectDownload}
            disabled={starting}
            className="inline-flex w-full items-center justify-center gap-2.5 rounded-full bg-[#00F5A0] px-6 py-3.5 text-sm font-bold text-[#050B14] transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#00D68B] disabled:opacity-70"
          >
            {starting ? (
              <CircleNotch size={18} weight="bold" className="animate-spin" />
            ) : (
              <DownloadSimple size={18} weight="bold" />
            )}
            {starting ? "Starting Download…" : "Download APK on this device"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
